// extracted by mini-css-extract-plugin
export default {"microplatePlayground":"microplatePlayground-CUh5Y","contents":"contents-dDXDR","item":"item-jBtc7","label":"label-PzYGc","plate":"plate-YGO5w"};